export default {
    isStartTeamTour    : state => state.isStartTeamTour,
    isStartAddTeamsTour: state => state.isStartAddTeamsTour,
    isStartAddAdminTour: state => state.isStartAddAdminTour,
    plansInfo          : state => state.plansInfo
};
